import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RelatedObjects from '../../../../../components/ui/RelatedObjects/RelatedObjects';
import useHousingStockRequests from '../../../../../queries/useHousingStockRequests';
import {
  setSelectedRequestId,
  setRequestDrawerVisible,
} from '../../../../../../../actions/requestCardActions';
import styles from '../Flat.module.scss';

const FlatRelatedObjects = () => {
  const params = useParams();

  const dispatch = useDispatch();

  const addressId = Number(params.pageTabId);

  const { data: requests, isFetching: isRequestsFetching } =
    useHousingStockRequests({ addressId }, { staleTime: Infinity });

  const handleItemClick = (requestId) => {
    dispatch(setSelectedRequestId(requestId));
    dispatch(setRequestDrawerVisible(true));
  };

  return (
    <RelatedObjects
      className={styles.grow}
      data={requests}
      loading={isRequestsFetching}
      onItemClick={handleItemClick}
    />
  );
};

export default FlatRelatedObjects;
